/**
 * Money formatting without zod, so browser bundles can import it through
 * `@luckymenu/core/client`. money.ts re-exports it.
 */

// Made on first use: creating a currency formatter costs a few milliseconds,
// which a phone would otherwise spend while the storefront menu loads.
let inrWhole: Intl.NumberFormat | undefined;
let inrFraction: Intl.NumberFormat | undefined;
const whole = () =>
	(inrWhole ??= new Intl.NumberFormat("en-IN", {
		style: "currency",
		currency: "INR",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}));
const fraction = () =>
	(inrFraction ??= new Intl.NumberFormat("en-IN", {
		style: "currency",
		currency: "INR",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}));

/**
 * Formats paise as rupees with lakh grouping: 12345600 → "₹1,23,456",
 * 1250 → "₹12.50". No decimals when the value is whole.
 */
export function formatPaise(paise: number): string {
	if (!Number.isSafeInteger(paise)) throw new RangeError(`Not an integer paise value: ${paise}`);
	const negative = paise < 0;
	const abs = Math.abs(paise);
	const rupees = Math.trunc(abs / 100);
	const rest = abs % 100;
	// Intl receives the exact decimal string, so no floating point rounding occurs.
	const formatted =
		rest === 0
			? whole().format(rupees)
			: fraction().format(`${rupees}.${String(rest).padStart(2, "0")}` as `${number}`);
	return negative ? `-${formatted}` : formatted;
}
